import { commitMutation, graphql } from 'react-relay';

import environment from 'src/util/environment';

const mutation = graphql`
  mutation AcceptNominatedTradeMutation($id: ID!, $tradePointId: String!) {
    acceptNominatedTrade(id: $id, tradePointId: $tradePointId) {
      id
      acceptedAt
      acceptedBy {
        id
        email
        givenName
        familyName
      }
    }
  }
`;

const AcceptNominatedTradeMutation = (tradeRuleIdSet, onCompleted, onError, formatMessage) => {
  const { id, tradePointId } = tradeRuleIdSet;

  commitMutation(
    environment,
    {
      mutation,
      variables: { id, tradePointId },
      onCompleted: (response) => { onCompleted(response, formatMessage); },
      onError,
      updater: (store) => {
        // Get the current user record from the store
        const ruleProxy = store.get(id);
        ruleProxy.setValue('TRADE_RULE_STATE_ACCEPTED', 'state');
      },
    },
  );
};

export default AcceptNominatedTradeMutation;
